module.exports = __webpack_public_path__ + "img/image56.93daa5d2.png";